// data/aboutAolCourses.js
const aboutAolCourses = [
  {
    title: 'Art of Living Part 1',
    image: '/images/SkyBreathMeditation.jpeg',
    link: 'https://event.us.artofliving.org/us-en/artoflivingpart1/?utm_source=organic&utm_medium=home&utm_content=allcourses&course_id=811569',
  },
  {
    title: 'Sahaj Samadhi Meditation',
    image: '/images/SahajSamadhiMeditation.jpeg',
    link: 'https://event.us.artofliving.org/us-en/sahajsamadhi/?utm_source=organic&utm_medium=home&utm_content=allcourses&course_id=999649',
  },
  {
    title: 'Art of Living Part 2',
    image: '/images/artofliving-part2.jpeg',
    link: 'https://event.us.artofliving.org/us-en/artoflivingpart2/?utm_source=organic&utm_medium=home&utm_content=allcourses&course_id=811570',
  },
  {
    title: 'Sri Sri Yoga',
    image: '/images/SriSriYoga.jpeg',
    link: `${process.env.NEXT_PUBLIC_AUTH_APP_URL}/us-en/lp/online-foundation-program?utm_source=organic&utm_medium=home&utm_content=allcourses&course_id=1004431&_gl=1*qy98xz*_gcl_au*MjExNDEwMzk2OS4xNzI1NDYxNjc4*_ga*MTQ2NzYyMjU4My4xNjkzNzQ1MTg0*_ga_53SWQFSBV0*MTczMTgyODcxMC4yOTcuMS4xNzMxODMwNjk1LjYwLjAuMA..`,
  },
];
export default aboutAolCourses;
